<template>
  <div class="detail-skeleton">
    <div class="detail-skeleton__banner">
      <el-skeleton animated>
        <template slot="template">
          <el-skeleton-item variant="image" class="detail-skeleton__banner-block" />
        </template>
      </el-skeleton>
    </div>

    <div class="detail-skeleton__body">
      <div class="detail-skeleton__intro">
        <el-skeleton animated>
          <template slot="template">
            <div class="detail-skeleton__intro-card">
              <el-skeleton-item variant="image" class="detail-skeleton__intro-image" />
              <div class="detail-skeleton__intro-content">
                <el-skeleton-item variant="h1" class="detail-skeleton__intro-title" />
                <el-skeleton-item variant="text" />
                <el-skeleton-item variant="text" style="width: 72%" />
                <el-skeleton-item variant="text" style="margin-top: 12px" />
                <el-skeleton-item variant="text" />
                <el-skeleton-item variant="text" style="width: 88%" />
              </div>
            </div>
          </template>
        </el-skeleton>
      </div>

      <div v-for="index in 2" :key="index" class="detail-skeleton__chapter">
        <el-skeleton animated>
          <template slot="template">
            <el-skeleton-item variant="h3" class="detail-skeleton__chapter-title" />
            <div class="detail-skeleton__cards">
              <div
                v-for="cardIndex in 2"
                :key="cardIndex"
                class="detail-skeleton__card"
              >
                <el-skeleton-item variant="image" class="detail-skeleton__card-image" />
                <div class="detail-skeleton__card-body">
                  <el-skeleton-item variant="h3" style="width: 42%" />
                  <el-skeleton-item variant="text" />
                  <el-skeleton-item variant="text" style="width: 76%" />
                </div>
              </div>
            </div>
          </template>
        </el-skeleton>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailSkeleton'
}
</script>

<style lang="scss" scoped>
.detail-skeleton {
  &__banner {
    margin-top: $header-height;
  }

  &__banner-block {
    width: 100%;
    height: rem(220);
    border-radius: 0;
  }

  &__body {
    max-width: $container-max-width;
    margin: 0 auto;
    padding: $spacing-2xl $content-padding $spacing-4xl;
  }

  &__intro {
    margin-bottom: $spacing-3xl;
  }

  &__intro-card {
    display: flex;
    gap: $spacing-xl;
    padding: $spacing-xl;
    background: $color-white;
    border-radius: 4px;
    box-shadow: 0 4px 24px rgba($color-brown-dark, 0.08);
  }

  &__intro-image {
    width: 48%;
    height: rem(320);
    flex-shrink: 0;
    border-radius: 4px;
  }

  &__intro-content {
    flex: 1;
    min-width: 0;
  }

  &__intro-title {
    width: 40%;
    margin-bottom: $spacing-base;
  }

  &__chapter {
    margin-bottom: $spacing-3xl;
  }

  &__chapter-title {
    width: 28%;
    margin-bottom: $spacing-base;
  }

  &__cards {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: $spacing-base;
  }

  &__card {
    display: flex;
    gap: $spacing-base;
    padding: $spacing-base;
    background: $color-white;
    border-radius: 4px;
    box-shadow: 0 2px 12px rgba($color-brown-dark, 0.06);
  }

  &__card-image {
    width: rem(140);
    height: rem(112);
    flex-shrink: 0;
    border-radius: 4px;
  }

  &__card-body {
    flex: 1;
    min-width: 0;
  }
}

@media (max-width: 960px) {
  .detail-skeleton {
    &__intro-card {
      flex-direction: column;
    }

    &__intro-image {
      width: 100%;
    }
  }
}

@media (max-width: 480px) {
  .detail-skeleton {
    &__cards {
      grid-template-columns: 1fr;
    }

    &__card {
      flex-direction: column;
    }

    &__card-image {
      width: 100%;
    }
  }
}
</style>
